import React from 'react'
import { UserSettings } from '../'
import { GA_PAGES } from '../../api/gaHelper'
import { page } from '../../hocs/page'

export default page(() => { return <UserSettings /> }, { pageView: GA_PAGES.SETTINGS, uiNavigationRoute: null })
